<template>
  <b-form-group :id="'msisdn_' + _uid" class="form-group-msisdn mandatory" :class="vflowGetFeedbackClasses('localMsisdn')">
    <div class="fieldset--label">
      <label :for="name">
        <slot name="lblInput">Deine Rufnummer (Default-Text)</slot>
      </label>
    </div>
    <input
      :name="name"
      :id="name"
      ref="inputMsisdn"
      type="tel"
      class="form-control"
      v-model="localMsisdn"
      required
      :placeholder="msisdnPlaceholder"
      @input="formatMSISDN"
      @focus="handleFocus"
      @blur="vflowInputBlurred('localMsisdn'); blurred_ = true;"
    >
    <b-form-invalid-feedback>
      <slot name="txtInvalidRequired" v-if="!$v.localMsisdn.required">Dies ist ein Pflichtfeld.</slot>
      <slot name="txtInvalidLoginUser" v-else>Ufff! Die Login-Daten sind ungültig. Bitte überprüfe deine Eingabe.</slot>
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import syncProperty from '../../mixins/syncProperty'
import isValid from '../../mixins/validators/isValid'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { isValidPhoneExt, phoneNoExpExt } from '@/mixins/validators/phone'
import validationFlow from '@/mixins/validators/validationFlow'
import { BFormGroup, BFormInvalidFeedback } from 'bootstrap-vue'

const isValidMSISDN = (v) => (v !== null && msisdnValidator.test(v.replace(/[^0-9+]/g, '')))
const msisdnValidator = /^(\+49)1[0-9]{9,12}$/
export default {
  name: 'msisdnInputValidation',
  data () {
    return {
      localMsisdn: '',
      knownNDCs: [
        '1501',
        '1502',
        '1505',
        '1508',
        '1510',
        '1511',
        '1512',
        '1513',
        '1514',
        '1515',
        '1516',
        '1517',
        '1518',
        '1519',
        '1520',
        '1521',
        '1522',
        '1523',
        '1525',
        '1526',
        '1531',
        '1551',
        '1555',
        '1556',
        '1563',
        '1566',
        '1567',
        '1570',
        '1573',
        '1575',
        '1576',
        '1577',
        '1578',
        '1579',
        '1588',
        '1590',
        '155',
        '160',
        '162',
        '163',
        '170',
        '171',
        '172',
        '173',
        '174',
        '175',
        '176',
        '177',
        '178',
        '179'
      ]
    }
  },
  mounted () {
    this.$v.$touch()
    this.invalid_ = this.$v.$invalid
    this.localMsisdn = this.msisdn_
    this.formatMSISDN()
  },
  components: {
    BFormGroup, BFormInvalidFeedback
  },
  mixins: [
    validationMixin,
    isValid,
    syncProperty('msisdn', 'msisdn_'),
    syncProperty('invalid', 'invalid_'),
    validationFlow
  ],
  methods: {
    setMsisdn (v) {
      this.msisdn_ = this.localMsisdn
    },
    handleFocus () {
      this.vflowInputFocused('localMsisdn')
      this.blurred_ = true
      this.$emit('focus')
    },
    msisdnFormatted (v) {
      let p = v.replace(/([^0-9+-])/g, '').trim()
      if (p !== '') {
        if (!isValidPhoneExt(p)) {
          // check if number starts with country code with missing 00 or +
          if (p.substring(0, 2) === '49') {
            p = '+' + p
          }
          // check if user entered a MSISDN starting without zero and country code, i.e. 17323456
          // check if input starts with a known ndc
          for (let n = 0; n < this.knownNDCs.length; n++) {
            if (p.substr(0, this.knownNDCs[n].length) === this.knownNDCs[n]) {
              p = '+49' + p
              break
            }
          }
        }

        if (isValidPhoneExt(p)) {
          const partCountryCode = p.replace(phoneNoExpExt, '$2')
          const partPrefix = p.replace(phoneNoExpExt, '$5')
          const partNo = p.replace(phoneNoExpExt, '$6')
          let formatted = (partCountryCode + (partCountryCode !== '0' ? ' ' : '') + partPrefix + ' ' + partNo).trim()

          // ensure we have a country code prefix
          if (formatted.substr(0, 1) !== '+') {
            // replace a double zero
            if (formatted.substr(0, 2) === '00') {
              formatted = '+' + formatted.substr(2)
            } else if (formatted.substr(0, 1) === '0') {
              formatted = '+49' + formatted.substr(1)
            } else if (formatted.substr(0, 1) === '1') {
              formatted = '+49' + formatted
            }
          }

          p = formatted
        }
      } else {
        p = ''
      }

      return p
    },
    formatMSISDN (pv) {
      this.$emit('input')
      const v = this.localMsisdn
      // handle value-edit event
      if (this.$refs.inputMsisdn.selectionStart < v.length) {
        this.localMsisdn = this.msisdnFormatted(v)
        this.$v.localMsisdn.$touch()
      } else {
        this.localMsisdn = this.msisdnFormatted(v)
        this.$v.localMsisdn.$touch()
      }

      this.setMsisdn(this.localMsisdn)
    }
  },
  watch: {
    '$v.$invalid': {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:invalid', newValue)
      }
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    msisdnPlaceholder: {
      type: String,
      default: ''
    }
  },
  computed: {
  },
  validations () {
    return {
      localMsisdn: {
        required,
        isValidMSISDN
      }
    }
  }
}
</script>
